import { ResponseCode } from "./types";

type CursorRequest = { cursor?: string };

type CursorResponse = {
  code: ResponseCode;
  cursor?: string;
};

/**
 * Загружает все элементы по курсору: вызывает api с cursor, пока он есть.
 * Универсален для любых API с пагинацией по cursor.
 *
 * @param api — функция API, принимает объект с cursor и опционально другими полями
 * @param getItems — извлекает массив элементов из ответа (напр. (r) => r.shop_zones)
 * @param baseParams — базовые параметры запроса без cursor (напр. { order_type }, { zone_id })
 */
export async function fetchAllWithCursor<TItem, TRequest extends CursorRequest, TResponse extends CursorResponse>(
  api: (params: TRequest) => Promise<TResponse>,
  getItems: (response: TResponse) => TItem[],
  base_params: Omit<TRequest, "cursor"> = {} as Omit<TRequest, "cursor">,
): Promise<TItem[] | undefined> {
  let cursor: string | null = null;
  const data: TItem[] = [];

  do {
    const result = await api({ ...base_params, cursor: cursor ?? undefined } as TRequest);

    if (result.code !== ResponseCode.OK) return undefined;

    cursor = result.cursor ?? null;
    data.push(...getItems(result));
  } while (cursor);

  return data;
}
